import axios from "axios";
import { SHARE_FIELDS } from "../../src/configurations/Urls";
import Session from "../helpers/SessionHelper";

const ShareFieldService = {
  async addShareFieldDetails(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(SHARE_FIELDS, payload, {
      headers: headers,
    });
    return response;
  },
  async updateShareFieldDetails(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.put(SHARE_FIELDS, payload, {
      headers: headers,
    });
    return response;
  },
};

export default ShareFieldService;
